module.exports = __webpack_public_path__ + "img/2-5.f129973c.svg";